<p-panel class="h-full">
  <div class="control">
    <label>Type</label>
    <p-select
      [options]="typeOptions"
      [(ngModel)]="ssbKonfigService.type"
      appendTo="body"
    />
  </div>
  <div class="control">
    <label>Nøgle</label>
    <input pInputText [(ngModel)]="ssbKonfigService.noegle" />
  </div>
  <div class="control">
    <label>Værdi</label>
    <input pInputText [(ngModel)]="ssbKonfigService.vaerdi" />
  </div>
  <p-button
    label="Nulstil"
    (click)="onClickReset()"
    icon="pi pi-times"
    severity="secondary"
    outlined
  />
</p-panel>
